import { eTipoPesquisaFiltroFuncionarios } from "@/enums/eTipoPesquisaFiltroFuncionarios";
import { eTipoPesquisaFiltroEstudantes } from "@/enums/eTipoPesquisaFiltroEstudantes";
import { eTipoPesquisaFiltroTurmas } from "@/enums/eTipoPesquisaFiltroTurmas";

const codigoProfessorSelectedTelaFiltro = parseInt(sessionStorage.getItem('codigoProfessorSelectedTelaFiltro') ?? localStorage.getItem('codigoProfessorSelectedTelaFiltro') ?? 'NaN');
const nomeProfessorSelectedTelaFiltro = sessionStorage.getItem('nomeProfessorSelectedTelaFiltro') ?? '';
const codigoEstudanteSelectedTelaFiltro = parseInt(sessionStorage.getItem('codigoEstudanteSelectedTelaFiltro') ?? localStorage.getItem('codigoEstudanteSelectedTelaFiltro') ?? 'NaN');
const codigoTurmaSelectedTelaFiltro = sessionStorage.getItem('codigoTurmaSelectedTelaFiltro') ?? '';
const tipoPesquisaFiltroFuncionarios = sessionStorage.getItem('eTipoPesquisaFiltroFuncionarios') as eTipoPesquisaFiltroFuncionarios ?? eTipoPesquisaFiltroFuncionarios.ProfessorCadastrado;
const tipoPesquisaFiltroEstudantes = sessionStorage.getItem('eTipoPesquisaFiltroEstudantes') as eTipoPesquisaFiltroEstudantes ?? eTipoPesquisaFiltroEstudantes.Todos;
const tipoPesquisaFiltroTurmas = sessionStorage.getItem('tipoPesquisaFiltroTurmas') as eTipoPesquisaFiltroTurmas ?? eTipoPesquisaFiltroTurmas.Escola;

const routeAfterSelectFiltroFuncionarios = sessionStorage.getItem('routeAfterSelectFiltroFuncionarios') ?? "";
const routeAfterSelectFiltroEstudantes = sessionStorage.getItem('routeAfterSelectFiltroEstudantes') ?? "";
const routeAfterSelectFiltroTurmas = sessionStorage.getItem('routeAfterSelectFiltroTurmas') ?? "";

export type State = {
    showModal: boolean;
    showModalFiltroEstudantes: boolean;
    showModalFiltroTurmas: boolean;
    showModalFiltroMultiTurmas: boolean;
    showModalAvisosNotificacoes: boolean;
    showModalLegado: boolean;
    codigoProfessorSelectedTelaFiltro: number;
    nomeProfessorSelectedTelaFiltro: string;
    codigoEstudanteSelectedTelaFiltro: number;
    codigoTurmaSelectedTelaFiltro: string;
    enumTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios;
    routeAfterSelectFiltroFuncionarios: string;
    enumTipoPesquisaFiltroEstudantes: eTipoPesquisaFiltroEstudantes;
    routeAfterSelectFiltroEstudantes: string;
    enumTipoPesquisaFiltroTurmas: eTipoPesquisaFiltroTurmas;
    routeAfterSelectFiltroTurmas: string;
}

export const state: State = {
    showModal: false,
    showModalFiltroEstudantes: false,
    showModalFiltroTurmas: false,
    showModalFiltroMultiTurmas: false,
    showModalAvisosNotificacoes: false,
    showModalLegado: false,
    codigoProfessorSelectedTelaFiltro: codigoProfessorSelectedTelaFiltro,
    codigoEstudanteSelectedTelaFiltro: codigoEstudanteSelectedTelaFiltro,
    codigoTurmaSelectedTelaFiltro: codigoTurmaSelectedTelaFiltro,
    nomeProfessorSelectedTelaFiltro: nomeProfessorSelectedTelaFiltro,
    enumTipoPesquisaFiltroFuncionarios: tipoPesquisaFiltroFuncionarios,
    routeAfterSelectFiltroFuncionarios: routeAfterSelectFiltroFuncionarios,
    enumTipoPesquisaFiltroEstudantes: tipoPesquisaFiltroEstudantes,
    routeAfterSelectFiltroEstudantes: routeAfterSelectFiltroEstudantes,
    enumTipoPesquisaFiltroTurmas: tipoPesquisaFiltroTurmas,
    routeAfterSelectFiltroTurmas: routeAfterSelectFiltroTurmas,

};

